<frontend-pull-refresh></frontend-pull-refresh>

<section class="px-3 pb-3">
  <h1 *ngIf ="location" class="pt-3">Public Waitlist</h1>
  <form *ngIf="publicWaitlistForm" role="form" [formGroup]="publicWaitlistForm" novalidate>
    <div class="row form-group">
      <div class="col-sm-5 col-md-5 col-lg-5 col-xl-4">
        <label for="settings-public-url-name" class="lead col-form-label">Public URL name</label>
        <p>Must be 12 or fewer characters and include only lowercase letters, numbers, and - or _ symbols.</p>
      </div>
      <div class="col-sm-5 mt-2">
        <input
          id="settings-public-url-name"
          type="text"
          class="form-control"
          name="publicUrl"
          formControlName="publicUrl"
          maxlength="12"
          [class.is-invalid]="publicWaitlistForm.get('publicUrl').invalid"
        >
        <control-messages [control]="publicWaitlistForm.get('publicUrl')" showUntoched="true"></control-messages>
      </div>
    </div>

    <div class="row form-group">
      <div class="col-sm-5 col-md-5 col-lg-5 col-xl-4">
        <label for="public-waitlist-view" class="col-form-label lead">Public waitlist view mode</label>
        <p>Allow people to check their place in line on the web. <span *ngIf="viewControl?.value && messagesContainLink">To disable this, remove the {{'{link}'}} to your public waitlist from your notifications.</span></p>
      </div>
      <div class="col-sm-7 col-md-7 col-lg-7 col-xl-5 mt-2">
        <div class="form-check">
          <div class="d-flex flex-row justify-content-start align-items-center">
            <label class="form-check-label">
              <input
                type="checkbox"
                class="form-check-input"
                id="public-waitlist-view"
                name="publicWaitlistView"
                [attr.disabled]="(viewControl?.value && messagesContainLink) ? true : null"
                formControlName="view">Enable
            </label>

            <span class="link-overflow pl-1" [hidden]="!viewControl?.value">
              (<a class="info-link" href="{{origin}}/p/waitlist/{{this.location.publicUrl}}" target="_blank">{{origin}}/p/waitlist/{{this.location.publicUrl}}</a>)
            </span>
          </div>
        </div>
      </div>
    </div>

    <div class="row form-group">
      <div class="col-sm-5 col-md-5 col-lg-5 col-xl-4">
        <label for="public-waitlist-add" class="col-form-label lead">Public waitlist add mode</label>
        <p>Allow people to add themselves to your list from the web.</p>
      </div>
      <div class="col-sm-7 col-md-7 col-lg-7 col-xl-5 mt-2">
        <div class="form-check">
          <div class="d-flex flex-row justify-content-start align-items-center">
            <label class="form-check-label">
              <input
                type="checkbox"
                class="form-check-input"
                id="public-waitlist-add"
                name="publicWaitlistAdd"
                formControlName="add">Enable
            </label>

            <span class="link-overflow pl-1" [hidden]="!publicWaitlistForm.get('add').value">
            (<a class="info-link" href="{{origin}}/p/check-in/{{this.location.publicUrl}}" target="_blank">{{origin}}/p/check-in/{{this.location.publicUrl}}</a>)
          </span>
          </div>
        </div>
      </div>
    </div>

    <div name="qrCodes" hidden *ngIf="publicCheckinUrl && publicWaitlistUrl && publicOnlineBookingUrl">
      <qrcode class="qr-waitlist" [allowEmptyString]="true" [qrdata]="publicWaitlistUrl"  elementType="url" [width]="600" [errorCorrectionLevel]="'M'"></qrcode>
      <qrcode class="qr-check-in" [allowEmptyString]="true" [qrdata]="publicCheckinUrl" elementType="url" [width]="600" [errorCorrectionLevel]="'M'"></qrcode>
      <qrcode class="qr-{{ location.displayOptions.labels.reservation_plural }}" [allowEmptyString]="true" [qrdata]="publicOnlineBookingUrl" elementType="url" [width]="600" [errorCorrectionLevel]="'M'"></qrcode>
    </div>

    <div class="row form-group">
      <div class="colsm-5 col-md-5 col-lg-5 col-xl-4">
        <label class="col-form-label lead">Direct links & embedding</label>
        <p>You can use direct links to your public pages, embed them on your website, or get a QR code.</p>
      </div>
      <div *ngIf="publicPages && publicPages.length; else noPublicPages" class="col-sm-7 col-md-7 col-lg-7 col-xl-5 mt-2">
        <div class="form-check">
          <frontend-dropdown
            elementId="public-pages-direct-links"
            formControlName="selectedPublicPage"
            placeholder="Select schedule"
            bindValue="value"
            bindLabel="name"
            (ngModelChange)="changeCurrentSelectedPage()"
            [items]="publicPages"
          ></frontend-dropdown>
        </div>

        <div class="d-flex flex-column mt-2 embed-linking">
          <common-radio-group
            class="mt-2"
            [items]="tabRadioItems"
            formControlName="selectedTab"
            uncheckedButtonClass="btn-info"
            checkedButtonClass="btn-info"
          ></common-radio-group>

          <div class="my-2" *ngIf="selectedPageTabData">
            <div *ngIf="selectedTab?.value === tabValues.DIRECT_LINK">
              <p>This is a direct link for clients to view {{ selectedPageTabData.dropdownPageName }}.</p>
              <input type="text" class="form-control" disabled [value]="selectedPageTabData.directLink">
              <button class="btn btn-info d-block mt-4" [copy-clipboard]="selectedPageTabData.directLink">Copy</button>
            </div>
            <div *ngIf="selectedTab?.value === tabValues.EMBED_PAGE">
              <p>Embed a Public {{ selectedPageTabData.dropdownPageName }} directly into your own website using HTML code below.</p>
              <textarea #embedPage
                        rows="4"
                        readonly
                        name="text"
                        class="form-control mt-1"
                        [value]="selectedPageTabData.embedPageCode"
              ></textarea>
              <button class="btn btn-info mt-4" [copy-clipboard]="embedPage.value">Copy</button>
            </div>
            <div *ngIf="selectedTab?.value === tabValues.ADD_BUTTON">
              <p>Embed a "{{selectedPageTabData.buttonText}}" button directly into your own website</p>
              <textarea #buttonCode
                        rows="6"
                        readonly
                        class="form-control mt-1"
                        [value]="selectedPageTabData.buttonCode"
              ></textarea>
              <button class="btn btn-info mt-4" [copy-clipboard]="buttonCode.value">Copy</button>
            </div>
            <div *ngIf="selectedTab?.value === tabValues.QR_CODE && (publicCheckinUrl || publicWaitlistUrl || publicOnlineBookingUrl)">
              <p>Get QR code for Public {{ selectedPageTabData.dropdownPageName }}.</p>
              <button class="btn btn-info" (click)="downloadQrCodeService.downloadQrCode(selectedPageTabData.qrCodeTagName)">Download QR code</button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row form-group" *ngIf="schedules.length && viewControl.value && addControl.value">
      <div class="col-sm-5 col-md-5 col-lg-5 col-xl-4">
        <label class="col-form-label lead">Schedule for public waitlist</label>
        <p>Select the schedules for which you want the public waitlist to be available. Empty/blank means it is always available.</p>
      </div>
      <div class="col-sm-7 col-md-7 col-lg-7 col-xl-5 mt-2">
        <div class="form-check">
          <frontend-dropdown
            bindValue="_id"
            class="w-100 fs-1"
            formControlName="schedule"
            elementId="public-pages-schedule"
            placeholder="Select schedule"
            bindLabel="name"
            [searchable]="false"
            [addTag]="false"
            [multiple]="true"
            [clearable]="true"
            [items]="schedules"
            (ngModelChange)="clearOtherScheduleValues($event)"
          ></frontend-dropdown>
        </div>
      </div>
    </div>

    <div class="row form-group" *ngIf="viewControl.value && addControl.value">
      <div class="col-sm-5 col-md-5 col-lg-5 col-xl-4">
        <label for="public-waitlist-add" class="col-form-label lead">Redirect mode</label>
        <p>Enable this to redirect to your waitlist page after someone adds themselves.</p>
      </div>
      <div class="col-sm-7 col-md-7 col-lg-7 col-xl-5 mt-2">
        <div class="form-check">
          <label class="form-check-label">
            <input type="checkbox"
                   class="form-check-input"
                   id="public-waitlist-redirect"
                   name="publicWaitlistRedirect"
                   formControlName="redirect">Enable
          </label>
        </div>
      </div>
    </div>

    <div class="row form-group" formGroupName="checkinCap" *ngIf="viewControl.value && addControl.value">
      <div class="col-sm-5 col-md-5 col-lg-5 col-xl-4">
        <label for="public-checkin-cap" class="col-form-label lead">Check-in cap</label>
        <p>Stop taking new check-ins when your waitlist hits its cap. It will reopen after the duration you set.</p>
      </div>
      <div class="col-sm-7 col-md-7 col-lg-7 col-xl-5 mt-2">
        <div class="mb-1">
          <div class="form-check">
            <label class="form-check-label">
              <input type="checkbox"
                     class="form-check-input"
                     id="public-checkin-cap"
                     name="checkinCapEnabled"
                     formControlName="enabled">Enable
            </label>
          </div>
        </div>
        <div class="mb-1" *ngIf="checkinCapEnabledControl?.value">
          <div class="form-group row">
            <label for="public-options-cap" class="col-xs-6 col-sm-5 col-xl-4 col-form-label">Cap *</label>
            <div class="col-xs-6 col-sm-7 col-xl-8">
              <input type="number"
                     id="public-options-cap"
                     class="form-control"
                     formControlName="cap"
                     [class.is-invalid]="checkinCapEnabledControl?.invalid && checkinCapEnabledControl?.touched"
                     name="checkinCapQuantity">
            </div>
          </div>
          <div class="form-group row">
            <label for="public-options-duration" class="col-xs-6 col-sm-5 col-xl-4 col-form-label">Duration * <br><span>(hours : minutes)</span></label>
            <div class="col-xs-6 col-sm-7 col-xl-8">
              <time-counter id="public-options-duration" formControlName="reopenDuration"></time-counter>
            </div>
          </div>
          <div class="form-group row">
            <label for="public-options-message" class="col-xs-6 col-sm-5 col-xl-4 col-form-label">Message *</label>
            <div class="col-xs-6 col-sm-7 col-xl-8">
             <textarea name="checkinCapMessage"
                       class="w-100 form-control"
                       id="public-options-message"
                       rows="6"
                       formControlName="message"
                       [class.is-invalid]="customMessageControl?.invalid && customMessageControl?.touched"
                       trTrimSpaces
             ></textarea>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row form-group" *ngIf="viewControl.value">
      <div class="col-sm-5 col-md-5 col-lg-5 col-xl-4">
        <label for="show-upcoming-reservations" class="col-form-label lead">Show upcoming {{location.displayOptions.labels.reservation_plural}} on public waitlist</label>
      </div>
      <div class="col-sm-7 col-md-7 col-lg-7 col-xl-5 mt-2">
        <div class="mb-1">
          <div class="form-check">
            <label class="form-check-label">
              <input type="checkbox" class="form-check-input" id="show-upcoming-reservations" name="showUpcomingReservations" formControlName="showUpcomingReservations">Enable</label>
          </div>
        </div>
      </div>
    </div>

    <ng-container *ngIf="showUpcomingReservationsControl?.value">

      <div class="row form-group">
        <div class="col-sm-5 col-md-5 col-lg-5 col-xl-4">
          <label for="show-checkedin-reservations-only" class="col-form-label lead">Show checked-in {{location.displayOptions.labels.reservation_plural}} only on public waitlist</label>
        </div>
        <div class="col-sm-7 col-md-7 col-lg-7 col-xl-5 mt-2">
          <div class="mb-1">
            <div class="form-check">
              <label class="form-check-label">
                <input type="checkbox" class="form-check-input" id="show-checkedin-reservations-only" formControlName="showOnlyCheckedInReservations">Enable</label>
            </div>
          </div>
        </div>
      </div>

      <div class="row form-group">
        <div class="col-sm-5 col-md-5 col-lg-5 col-xl-4">
          <label for="allow-reservations-checkin" class="col-form-label lead">Allow upcoming {{location.displayOptions.labels.reservation_plural}} to check-in from public waitlist</label>
        </div>
        <div class="col-sm-7 col-md-7 col-lg-7 col-xl-5 mt-2">
          <div class="mb-1">
            <div class="form-check">
              <label class="form-check-label">
                <input type="checkbox" class="form-check-input" id="allow-reservations-checkin" name="allowReservationsCheckin" formControlName="allowReservationsCheckin">Enable</label>
            </div>
          </div>
        </div>
      </div>

    </ng-container>

    <div class="row form-group" *ngIf="showUpcomingReservationsControl?.value && allowReservationsCheckinControl?.value">
      <div class="col-sm-5 col-md-5 col-lg-5 col-xl-4">
        <label for="enable-reservations-checkin-verification" class="col-form-label lead">Require phone number verification of {{location.displayOptions.labels.reservation_plural}} when checking in from public waitlist</label>
      </div>
      <div class="col-sm-7 col-md-7 col-lg-7 col-xl-5 mt-2">
        <div class="mb-1">
          <div class="form-check">
            <label class="form-check-label">
              <input type="checkbox" class="form-check-input" id="enable-reservations-checkin-verification" name="enableReservationsCheckinVerification" formControlName="enableReservationsCheckinVerification">Enable</label>
          </div>
        </div>
      </div>
    </div>

    <div class="row form-group" formGroupName="geofence">
      <div class="col-sm-5 col-md-5 col-lg-5 col-xl-4">
        <label for="public-waitlist-geofence-enabled" class="col-form-label lead">Geofence</label>
        <p>Allow sign up only if user is within your configured distance in feet. Specify the location address on <a routerLink="/settings/location/info">Location info page</a> to enable the feature.</p>
      </div>
      <div class="col-sm-7 col-md-7 col-lg-7 col-xl-5 mt-2">
        <div class="form-check">
          <label class="form-check-label">
            <input
              type="checkbox"
              class="form-check-input"
              id="public-waitlist-geofence-enabled"
              name="publicWaitlistGeofenceEnabled"
              formControlName="enabled"
            >Enable
          </label>
        </div>

        <div class="form-group row align-items-center" [hidden]="!geofenceEnabledControl.value">
          <label for="public-waitlist-geofence-distance" class="col-xs-6 col-sm-5 col-xl-4 col-form-label">Distance</label>
          <div class="col-xs-6 col-sm-7 col-xl-8">
            <input
              id="public-waitlist-geofence-distance"
              type="number"
              step="10"
              class="form-control"
              name="distance"
              formControlName="distance"
              [class.is-invalid]="publicWaitlistForm.get('geofence.distance')?.errors"
            >
          </div>
        </div>

        <div class="form-group row align-items-center" [hidden]="!geofenceEnabledControl.value">
          <label for="public-waitlist-geofence-message" class="col-xs-6 col-sm-5 col-xl-4 col-form-label">Message</label>
          <div class="col-xs-6 col-sm-7 col-xl-8">
           <textarea
             id="public-waitlist-geofence-message"
             class="form-control"
             name="message"
             formControlName="message"
             [class.is-invalid]="publicWaitlistForm.get('geofence.message')?.errors"
           ></textarea>
          </div>
        </div>

        <div class="form-group row align-items-center" [hidden]="!geofenceEnabledControl.value">
          <label for="public-waitlist-geofence-checkin" class="col-xs-6 col-sm-5 col-xl-4 col-form-label">Checkin</label>
          <div class="col-xs-6 col-sm-7 col-xl-8">
            <input
              type="checkbox"
              class="form-check-input"
              id="public-waitlist-geofence-checkin"
              name="checkin"
              formControlName="checkin"
            >
          </div>
        </div>

        <div class="form-group row align-items-center" [hidden]="!geofenceEnabledControl.value">
          <label for="public-waitlist-geofence-waitlist" class="col-xs-6 col-sm-5 col-xl-4 col-form-label">Waitlist</label>
          <div class="col-xs-6 col-sm-7 col-xl-8">
            <input
              type="checkbox"
              class="form-check-input"
              id="public-waitlist-geofence-waitlist"
              name="waitlist"
              formControlName="waitlist"
            >
          </div>
        </div>

        <div class="form-group row align-items-center" [hidden]="!geofenceEnabledControl.value">
          <label for="public-waitlist-geofence-reservation" class="col-xs-6 col-sm-5 col-xl-4 col-form-label" [innerText]="location.displayOptions.labels.reservation | capitalize"></label>
          <div class="col-xs-6 col-sm-7 col-xl-8">
            <input
              type="checkbox"
              class="form-check-input"
              id="public-waitlist-geofence-reservation"
              name="reservation"
              formControlName="reservation"
            >
          </div>
        </div>
      </div>
    </div>

    <div class="row form-group">
      <div class="col-sm-5 col-md-5 col-lg-5 col-xl-4">
        <label for="public-waitlist-upload" class="col-form-label lead">Custom Image Upload</label>
        <p>Upload a custom logo (png, gif, jpg, webp) for your public waitlist.</p>
      </div>
      <div class="col-sm-12 col-md-7 col-lg-7 col-xl-5 mt-2 mt-2">
        <div class="row" *ngIf="isImageVisible">
          <div class="col-md-8 col-lg-8 col-xl-8 mt-2">
            <div class="customized-img">
              <img [src]="imageControl.value">
            </div>
            <div>
              <a href="javascript:void(0)" (click)="removeImage()">delete image</a>
            </div>
          </div>
        </div>
        <div class="row form-group">
          <div class="col-xs-12 col-lg-9">
            <input type="file"
                   class="form-control"
                   id="public-waitlist-upload"
                   name="publicWaitlistImage"
                   accept="image/*"
                   [multiple]="false"
                   #takeInput
                   (change)="onAddFile($event.target.files)"/>
          </div>
          <div class="col-xs-12 col-lg-3 mt-1">
            <button *ngIf="this.file"
                    class="btn btn-info"
                    (click)="uploadFile()">Upload
            </button>
          </div>
        </div>
        <div class="row form-group" *ngIf="imageControl?.value">
          <div class="col-sm-12 col-md-12 col-lg-12 col-xl-12 mt-4">
            <frontend-dropdown
              formControlName="position"
              bindLabel="name"
              bindValue="value"
              [items]="imageDisplayOptions"
              [titleCase]="true"
            ></frontend-dropdown>
          </div>
        </div>
      </div>
    </div>

    <div class="row form-group" *ngIf="addControl?.value || location.bookingOptions.onlineReservationsEnabled">
      <div class="col-lg-5 col-xl-4">
        <label class="col-form-label lead">{{fieldLabelsNoteControl?.value || 'Special requests'}} types</label>
        <p>Drop-down options for the "{{fieldLabelsNoteControl?.value || 'Special requests'}}" input in waitlist add mode.</p>
      </div>
      <div class="col-lg-7 col-xl-5 mt-2" formGroupName="fieldOptions">
        <frontend-dropdown-plain
          elementId="settings-note-options"
          [items]="publicWaitlistForm.get('fieldOptions.noteOptions').value"
          [addTag]="true"
          [multiple]="true"
          formControlName="noteOptions"
          [placeholder]="fieldLabelsNoteControl?.value || 'Special requests'"
          [clearable]="true"
        ></frontend-dropdown-plain>
      </div>
    </div>

    <!-- manage fields -->
    <div class="manage-fields">
      <table *ngIf="manageFieldsList$ | async as manageFieldsList" class="w-100 mb-3">
        <tr>
          <th *ngIf="!publicPagesDisabled || onlineBookingsEnabled">
            <div class="v-center">
              <p class="lead">Manage fields</p>
            </div>
          </th>

          <th *ngIf="isWaitlistViewModeEnabledOnly || onlineBookingsEnabled">
            <div class="all-center checkbox-col lead">
              <p class="lead">View</p>
            </div>
          </th>

          <th *ngIf="isWaitlistAddModeEnabledOnly || onlineBookingsEnabled">
            <div class="all-center checkbox-col lead">
              <p class="lead">Add</p>
            </div>
          </th>

          <th *ngIf="isWaitlistAddModeEnabledOnly || onlineBookingsEnabled">
            <div class="all-center checkbox-col lead">
              <p class="lead">Required</p>
            </div>
          </th>

          <th *ngIf="viewControl?.value || addControl?.value || onlineBookingsEnabled">
            <div class="lead pl-2">
              <p class="lead input-col">Label</p>
            </div>
          </th>
        </tr>

        <tr *ngFor="let field of manageFieldsList">
          <!-- name -->
          <td *ngIf="!publicPagesDisabled || onlineBookingsEnabled">
            <div class="v-center">{{ field.name }}</div>
          </td>

          <!-- view -->
          <td *ngIf="isWaitlistViewModeEnabledOnly || onlineBookingsEnabled" formGroupName="fieldOptions">
            <div class="all-center checkbox-col">
              <ng-container *ngIf="viewOptions[field.sharedName] && viewOptions[field.sharedName]?.defaultValue">
                <ng-template [ngTemplateOutlet]="defaultChecked" [ngTemplateOutletContext]="{ controlName: addOptions[field.sharedName].id, formGroup: 'fieldOptions' }"></ng-template>
              </ng-container>
              <ng-container *ngIf="viewOptions[field.sharedName] && !viewOptions[field.sharedName]?.defaultValue">
                <input type="checkbox" id="public-waitlist-fields-{{viewOptions[field.sharedName].id}}" [formControlName]="viewOptions[field.sharedName].id">
              </ng-container>
            </div>
          </td>

          <!-- add -->
          <td *ngIf="isWaitlistAddModeEnabledOnly || onlineBookingsEnabled" formGroupName="fieldOptions">
            <div class="all-center checkbox-col">
              <ng-container *ngIf="addOptions[field.sharedName] && addOptions[field.sharedName]?.defaultValue">
                <ng-template [ngTemplateOutlet]="defaultChecked"></ng-template>
              </ng-container>
              <ng-container *ngIf="addOptions[field.sharedName] && !addOptions[field.sharedName]?.defaultValue">
                <input type="checkbox" [formControlName]="addOptions[field.sharedName].id">
              </ng-container>
            </div>
          </td>

          <!-- required -->
          <td *ngIf="isWaitlistAddModeEnabledOnly || onlineBookingsEnabled">
            <div class="all-center checkbox-col" formGroupName="requiredFields">
              <input type="checkbox" [formControlName]="field.id">
            </div>
          </td>

          <!-- label -->
          <td *ngIf="viewControl?.value || addControl?.value || onlineBookingsEnabled" formGroupName="fieldLabels">
            <div class="pl-2">
              <ng-container *ngIf="fieldLabelsControl?.get(field.id);">
                <div class="input-col">
                  <input type="text"
                         id="public-waitlist-label-{{field.id}}"
                         name="publicWaitlistFieldLabelsName"
                         class="form-control"
                         [formControlName]="field.id"
                         [class.is-invalid]="fieldLabelsControl?.get(field.id).invalid && fieldLabelsControl?.get(field.id).touched" />
                  <control-messages [control]="fieldLabelsControl?.get(field.id)"></control-messages>
                </div>
              </ng-container>
            </div>
          </td>
        </tr>
      </table>
    </div>
    <!-- manage fields: end-->

    <div *ngIf="viewControl?.value || addControl?.value">

      <div class="row form-group" formGroupName="fieldOptions">
        <div class="col-lg-5 col-xl-4">
          <label class="col-form-label lead">Select fields to display</label>
          <p>Choose which fields to display on your public waitlist.</p>
        </div>

        <div class="col-lg-7 col-xl-5 mt-2" *ngIf="viewControl?.value || addControl?.value">
          <div class="form-check" *ngFor="let field of publicWaitFieldsOptions">
            <label class="form-check-label">
              <input type="checkbox"
                     class="form-check-input"
                     id="public-waitlist-fields-{{field.id}}"
                     [formControlName]="field.id">
              {{field.name}}
            </label>
          </div>
        </div>
      </div>

      <div class="row form-group" *ngIf="addControl?.value">
        <div class="col-lg-5 col-xl-4">
          <label for="public-waitlist-field-settings-max-size" class="col-form-label lead">Field settings</label>
          <p>Options for controlling the inputs of your add to waitlist page.</p>
        </div>
        <div class="col-lg-7 col-xl-5 mt-2" *ngIf="publicWaitlistForm.get('fieldOptions.size_add').value">
          <div class="form-group row" formGroupName="fieldSettings">
            <label for="public-waitlist-field-settings-max-size" class="col-xs-6 col-sm-5 col-xl-4 col-form-label">Max {{location.displayOptions.labels.customer}} size</label>
            <div class="col-xs-6 col-sm-7 col-xl-8">
              <input type="number"
                     id="public-waitlist-field-settings-max-size"
                     name="publicWaitlistFieldSettingsMaxSize"
                     min="1"
                     class="form-control"
                     formControlName="maxSize"
                     [class.is-invalid]="fieldLabelsMaxSizeControl?.invalid && fieldLabelsMaxSizeControl?.touched" />
              <control-messages [control]="fieldLabelsMaxSizeControl"></control-messages>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div *ngIf="viewControl?.value || addControl?.value">

      <div class="row form-group">
        <div class="col-lg-5 col-xl-4">
          <label class="col-form-label lead">Custom Text</label>
          <p>Enter your own text to be added to the headers and footers of the public waitlist. If you want to use value of your '{{ location.displayOptions.labels.reservation | titlecase }}  label' - use <strong>{{'{reservationPlural}'}}</strong> for plural and <strong>{{'{reservationLabel}'}}</strong> for single values.</p>
        </div>
        <div class="col-lg-7 col-xl-5 mt-2" formGroupName="customText">
          <div *ngIf="customTextPages$ | async as customTextPages">
            <div class="form-check d-flex flex-row mb-2">
              <frontend-dropdown
                elementId="public-pages"
                formControlName="publicPageSection"
                bindValue="value"
                bindLabel="name"
                (ngModelChange)="selectPublicPage()"
                [items]="customTextPages"
                [titleCase]="true"
                minWidth="12rem"
              ></frontend-dropdown>

              <div class="d-flex flex-row">
                <common-radio-group
                  [items]="modeRadioItems"
                  formControlName="publicPageMode"
                  uncheckedButtonClass="btn-info"
                  checkedButtonClass="btn-info"
                  class="ml-2"
                ></common-radio-group>
              </div>
            </div>

            <div *ngIf="isWaitlistViewSelected">
              <quill-editor
                [styles]="{'background-color': editorBackgroundColor}"
                (onEditorChanged)="formatTextColor($event)"
                [formControl]="customTextWaitlistViewControl"
                [modules]="editorConfig"
                placeholder="Type here..."
                format="html"
              >
              </quill-editor>
            </div>

            <div *ngIf="isWaitlistAddSelected">
              <quill-editor
                [styles]="{'background-color': editorBackgroundColor}"
                (onEditorChanged)="formatTextColor($event)"
                [formControl]="customTextWaitlistAddControl"
                [modules]="editorConfig"
                placeholder="Type here..."
                format="html"
              >
              </quill-editor>
            </div>

            <div *ngIf="isBookingsViewSelected">
              <quill-editor
                [styles]="{'background-color': editorBackgroundColor}"
                (onEditorChanged)="formatTextColor($event)"
                [formControl]="customTextBookingsViewControl"
                [modules]="editorConfig"
                placeholder="Type here..."
                format="html"
              >
              </quill-editor>
            </div>

            <div *ngIf="isBookingsAddSelected">
              <quill-editor
                [styles]="{'background-color': editorBackgroundColor}"
                (onEditorChanged)="formatTextColor($event)"
                [formControl]="customTextBookingsAddControl"
                [modules]="editorConfig"
                placeholder="Type here..."
                format="html"
              >
              </quill-editor>
            </div>

            <div *ngIf="isFooterSelected">
              <quill-editor
                [styles]="{'background-color': editorBackgroundColor}"
                (onEditorChanged)="formatTextColor($event)"
                [formControl]="footerControl"
                [modules]="editorConfig"
                placeholder="Type here..."
                format="html"
              >
              </quill-editor>
            </div>

            <div *ngIf="isClosedSelected">
              <quill-editor
                [styles]="{'background-color': editorBackgroundColor}"
                (onEditorChanged)="formatTextColor($event)"
                [formControl]="publicWaitlistForm.get('customText.closed')"
                [modules]="editorConfig"
                placeholder="Type here..."
                format="html"
              >
              </quill-editor>
            </div>
          </div>
        </div>
      </div>

      <div class="row form-group">
        <div class="col-sm-5 col-md-5 col-lg-5 col-xl-4">
          <label for="public-waitlist-custom-message-enable" class="col-form-label lead">Custom message</label>
          <p>Show custom message when the public waitlist is empty and display it instead of the check-in form.</p>
        </div>
        <div class="col-sm-7 col-md-7 col-lg-7 col-xl-5 mt-2">
          <div class="form-check">
            <label class="form-check-label">
              <input
                type="checkbox"
                class="form-check-input"
                id="public-waitlist-custom-message-enable"
                name="publicWaitlistCustomMessage"
                [formControl]="customMessageEnabledControl"
              >Enable
            </label>
          </div>

          <div class="form-group row" [hidden]="!customMessageEnabledControl?.value">
            <label for="public-options-cap" class="col-xs-6 col-sm-5 col-xl-4 col-form-label">Message</label>
            <div class="col-xs-6 col-sm-7 col-xl-8">
                <textarea
                  id="public-waitlist-custom-message-text"
                  class="form-control"
                  [formControl]="customMessageControl"
                  [class.is-invalid]="customMessageControl?.errors"
                  name="customMessage"
                  rows="4"
                ></textarea>
            </div>
          </div>
        </div>
      </div>

      <div class="row form-group">
        <div class="col-lg-5 col-xl-4">
          <label for="public-waitlist-theme-background" class="col-form-label lead">Theme colors</label>
          <p>Enter your own colors to change the look and feel of your waitlist</p>
        </div>
        <div class="col-lg-7 col-xl-5 mt-2">
          <div formGroupName="theme" >
            <div class="form-group row">
              <label for="public-waitlist-theme-background" class="col-xs-6 col-sm-5 col-xl-4 col-form-label">Background Color</label>
              <tablesready-color-picker
                id="public-waitlist-theme-background"
                formControlName="backgroundColor"
              >
              </tablesready-color-picker>
            </div>
            <div class="form-group row">
              <label for="public-waitlist-theme-color" class="col-xs-6 col-sm-5 col-xl-4 col-form-label">Interior Container Color</label>
              <tablesready-color-picker
                id="public-waitlist-theme-color"
                formControlName="formBackgroundColor"
              ></tablesready-color-picker>
            </div>
            <div class="form-group row">
              <label for="public-waitlist-theme-body" class="col-xs-6 col-sm-5 col-xl-4 col-form-label">Main Text Color</label>
              <tablesready-color-picker
                id="public-waitlist-theme-body"
                formControlName="bodyColor"
              ></tablesready-color-picker>
            </div>
            <div class="form-group row">
              <label for="public-waitlist-theme-wait" class="col-xs-6 col-sm-5 col-xl-4 col-form-label">Estimated Wait Color</label>
              <tablesready-color-picker
                id="public-waitlist-theme-wait"
                formControlName="estimatedWaitColor"
              ></tablesready-color-picker>
            </div>
            <div class="form-group row">
              <label for="public-waitlist-theme-column" class="col-xs-6 col-sm-5 col-xl-4 col-form-label">Column Name Colors</label>
              <tablesready-color-picker
                id="public-waitlist-theme-column"
                formControlName="tableHeaderColor"
              ></tablesready-color-picker>
            </div>
            <div class="form-group row">
              <label for="public-waitlist-theme-addbg" class="col-xs-6 col-sm-5 col-xl-4 col-form-label">Add to Waitlist Button Color</label>
              <tablesready-color-picker
                id="public-waitlist-theme-addbg"
                formControlName="addButtonBackgroundColor"
              ></tablesready-color-picker>
            </div>
            <div class="form-group row">
              <label for="public-waitlist-theme-add" class="col-xs-6 col-sm-5 col-xl-4 col-form-label">Add to Waitlist Text Color</label>
              <tablesready-color-picker
                id="public-waitlist-theme-add"
                formControlName="addButtonColor"
              ></tablesready-color-picker>
            </div>
            <div class="form-group row">
              <label for="public-waitlist-theme-highlight" class="col-xs-6 col-sm-5 col-xl-4 col-form-label">Row highlight color for customer</label>
              <tablesready-color-picker
                id="public-waitlist-theme-highlight"
                formControlName="highlightColor"
              ></tablesready-color-picker>
            </div>
            <div class="form-group row">
              <label class="col-xs-6 col-sm-5 col-xl-4 col-form-label">Waitlist Cap Color</label>
              <tablesready-color-picker
                id="public-waitlist-theme-cap"
                formControlName="header1Color"
              ></tablesready-color-picker>
            </div>
          </div>
          <div class="form-group row" formGroupName="fieldOptions">
            <label for="public-waitlist-theme-striping" class="col-xs-6 col-sm-5 col-xl-4 col-form-label">Shade every other line (improves readability)</label>
            <div class="col-3 mt-2">
              <input type="checkbox"
                     id="public-waitlist-theme-striping"
                     name="publicWaitlistThemeStriping"
                     class="form-check-input ml-0"
                     formControlName="striped"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="d-flex justify-content-center form-group">
      <button class="m-1 btn btn-success"
              (click)="savePublicWaitlist()"
              angularticsCategory="settings"
              angulartics2On="click"
              angularticsAction="Save Public Waitlist Settings"
              [disabled]="publicWaitlistForm.pristine || publicWaitlistForm.invalid ">Save
      </button>
      <button class="m-1 btn btn-info"
              title="Reset to default settings"
              (click)="resetToDefaultSettings()"
              angularticsCategory="settings"
              angulartics2On="click"
              angularticsAction="Reset Public Waitlist Settings">
        Reset
      </button>
    </div>

  </form>

  <ng-template #noPublicPages>
    <p>Please enable your public pages</p>
  </ng-template>

  <ng-template #defaultChecked>
    <input type="checkbox" disabled="true" checked="true">
  </ng-template>
</section>
